import React from 'react';
import { Box, Typography, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Views = ({ viewValue }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    if (
        !viewValue ||
        typeof viewValue.yearCountSum !== 'number' ||
        typeof viewValue.monthSum !== 'number' ||
        typeof viewValue.daySum !== 'number'
    ) {
        return <div>{t('dataUnavailable')}</div>;
    }

    return (
        <Box
            style={{
                marginTop: 60,
                marginBottom: 60,
            }}
        >
            <Grid container spacing={isSmallScreen ? 2 : 4}>
                <Grid item xs={12} md={8}>
                    <Box
                        style={{
                            borderRight: isSmallScreen ? 'none' : '1px solid #d8d5d5',
                            padding: 20,
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 20,
                            }}
                        >
                            <Box
                                style={{
                                    width: '20%',
                                    borderTop: '8px solid #3d629c',
                                }}
                            ></Box>
                            <Box
                                style={{
                                    width: '80%',
                                    borderTop: '2px solid #d8d5d5',
                                }}
                            ></Box>
                        </Box>
                        <Typography
                            style={{
                                fontSize: 25,
                                color: '#3d629c',
                                fontWeight: 700,
                                marginBottom: 20,
                                fontFamily: '"Manrope", sans-serif',
                            }}
                        >
                            {t('access')}
                        </Typography>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/day.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('today')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.daySum}
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/week.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('week')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.weekSum}
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/month.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('month')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.monthSum}
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 10,
                            }}
                        >
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <Box
                                    style={{
                                        height: 16,
                                        width: 16,
                                        backgroundImage: 'url(/icon/year.png)',
                                        marginRight: 5,
                                    }}
                                ></Box>
                                <Typography
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        fontFamily: '"Manrope", sans-serif',
                                    }}
                                >
                                    {t('total')}
                                </Typography>
                            </Box>
                            <Typography
                                style={{
                                    fontSize: 20,
                                    fontWeight: 400,
                                    fontFamily: '"Manrope", sans-serif',
                                }}
                            >
                                {viewValue.yearCountSum}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography
                        style={{
                            fontSize: 25,
                            fontWeight: 500,
                            marginBottom: 10,
                            fontFamily: '"Manrope", sans-serif',
                        }}
                    >
                        {t('social')}
                    </Typography>
                    <Box>
                        <iframe
                            src="https://www.facebook.com/v23.0/plugins/page.php?adapt_container_width=true&app_id=&channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df16e594aa5c5a35dc%26domain%3Ddevelopers.facebook.com%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fdevelopers.facebook.com%252Ff93d6ff314d5bbd27%26relation%3Dparent.parent&container_width=734&hide_cover=false&href=https%3A%2F%2Fwww.facebook.com%2Fkhanlor.mn&locale=en_US&sdk=joey&show_facepile=true&small_header=false&tabs=timeline"
                            style={{
                                width: '100%',
                                height: 331,
                                border: 'none',
                                overflow: 'hidden',
                            }}
                            scrolling="no"
                            frameBorder="0"
                            allow="encrypted-media"
                        ></iframe>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Views;
